import { useAtom } from "jotai";
import {
	type ExpenseFormEntry,
	expenseEntrySchema,
} from "web_myplann/Finances/Forms/expenseEntrySchema";
import { useTentativeEntriesForm } from "web_myplann/Finances/Forms/useTentativeEntriesForm";
import { createTentativeExpense } from "web_myplann/Finances/Helpers/createTentativeExpense";
import { isDetailedExpenses } from "web_myplann/Finances/Helpers/isDetailedExpenses";
import { sumMonthlyPayments } from "web_myplann/Finances/Helpers/sumMonthlyPayments";
import { financeState } from "web_myplann/Finances/State/FinanceAtom";
import type { TentativeEntriesModel } from "web_myplann/Finances/Types/TentativeEntriesModel";

export type ExpenseFormModel = TentativeEntriesModel<ExpenseFormEntry>;

export const useExpenseV2Form = () => {
	const [finance, setFinance] = useAtom(financeState);

	const {
		entries,
		replace,
		removeEntry,
		setValue,
		onSubmit,
		exact,
		total,
		setExact,
		setManualTotal,
		hasUnconfirmedChanges,
	} = useTentativeEntriesForm({
		entrySchema: expenseEntrySchema,
		entries: finance.expenses,
		isDetailed: isDetailedExpenses(finance.expenses),
		sum: sumMonthlyPayments,
		createPlaceholder: createTentativeExpense,
		save: (expenses) => setFinance({ ...finance, expenses }),
	});

	return {
		expenses: entries,
		expensesReplace: replace,
		removeExpense: removeEntry,
		setValue,
		onSubmit,
		exact,
		total,
		setExact,
		setManualTotal,
		hasUnconfirmedChanges,
	};
};
